import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {observer} from 'mobx-react';

interface ScanResultAdvancedButtonProps {
    onClick: () => void;
    text: string;
}

@observer
export class ScanResultAdvancedButton extends TechseeBaseComponent<ScanResultAdvancedButtonProps> {
    renderInternal() {
        const {onClick, text} = this.props;

        return (
            <div className='scan-result-advanced-button-container'>
                <button className={'scan-result-advanced-button'} type={'button'} onClick={() => onClick()}>
                    {' '}
                    {text}
                </button>
            </div>
        );
    }
}
